// useBookmakerBadges.ts
import { useMemo } from "react";
import { Sport, TeamInfo } from "../utils/types"; // adjust import to your actual location

// --- Config: IDs and thresholds live here, not scattered in JSX ---
const NOVIBET_EUROLEAGUE_COMPETITION_ID = "sr:competition:138";
const NOVIBET_EUROLEAGUE_TEAM_IDS = new Set([
  "sr:competitor:3501",
  "sr:competitor:3508",
]);

const NOVIBET_SOCCER_WORLDCUP_COMPETITION_ID = "sr:competition:16";

const STOIXIMAN_SOCCER_GREEK_SUPERLEAGUE_COMPETITION_ID = "sr:competition:185";
const STOIXIMAN_VISIBLE_VIEWS = new Set(["All", "Matchcenter"]);


interface SponsorLogoContext {
  sport: Sport;
  seasonCompetitionId: string;
  providerView: string;
  isBreakpointXL: boolean;
  teams: {
    home: TeamInfo;
    away: TeamInfo;
  };
}

interface SponsorLogos {
  showStoiximanBadge: boolean;
  showNovibetBadge: boolean;
  showNovibetBadgeEuroleague: boolean;
}

const useCompetitionSponsor = ({
  sport,
  seasonCompetitionId,
  providerView,
  isBreakpointXL,
  teams,
}: SponsorLogoContext): SponsorLogos => {
  return useMemo(() => {
    const showStoiximanBadge =
      (sport === Sport.BASKETBALL && STOIXIMAN_VISIBLE_VIEWS.has(providerView)) ||
      (seasonCompetitionId === STOIXIMAN_SOCCER_GREEK_SUPERLEAGUE_COMPETITION_ID && isBreakpointXL);

    const showNovibetBadge =
      sport === Sport.SOCCER && seasonCompetitionId === NOVIBET_SOCCER_WORLDCUP_COMPETITION_ID;

    const showNovibetBadgeEuroleague =
      sport === Sport.BASKETBALL &&
      seasonCompetitionId === NOVIBET_EUROLEAGUE_COMPETITION_ID &&
      (NOVIBET_EUROLEAGUE_TEAM_IDS.has(teams.away.sportRadarCompetitorId) ||
        NOVIBET_EUROLEAGUE_TEAM_IDS.has(teams.home.sportRadarCompetitorId));

    return { showStoiximanBadge, showNovibetBadge, showNovibetBadgeEuroleague };
  }, [
    sport,
    seasonCompetitionId,
    providerView,
    isBreakpointXL,
    teams.home.sportRadarCompetitorId,
    teams.away.sportRadarCompetitorId,
  ]);
}

export default useCompetitionSponsor